import React from 'react';
import { tw } from 'twind';
import { Button } from './Button';
import { useCartStore } from 'store/cart';

export interface ActionBarProps {
  nextLabel: string;
  nextDisabled: boolean;
  nextLoading?: boolean;
  nextAction: Function;
  nextDescription?: any;
  buttonStyle?: React.CSSProperties;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  nextAction,
  nextDescription,
  nextDisabled,
  nextLoading,
  nextLabel,
  buttonStyle,
  children,
}) => {
  const { theme } = useCartStore();

  const onNextClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    nextAction();
  };

  return (
    <div className={tw`fixed bottom-0 w-full shadow-action-bar z-10`}>
      {children}

      <div className={tw` bg-white p-4 w-full flex align-middle items-center`}>
        <div className={tw`text-xs text-[#777777]`}>Powered by CreatorCart™</div>
        <div className={tw`items-end flex flex-col flex-grow mr-3`}>{nextDescription}</div>
        <Button
          className={tw`inline-flex items-center justify-center px-6 py-3 text-sm leading-4 font-bold bg-${theme} text-white relative disabled:cursor-not-allowed focus:outline-none focus:ring-offset-2 focus:ring-white-500 disabled:opacity-60 text-center`}
          type="submit"
          disabled={nextDisabled}
          loading={nextLoading}
          onClick={onNextClick}
          style={buttonStyle}
          loadingIndicatorStyle={{ width: 15, height: 15 }}
        >
          {nextLabel}
        </Button>
      </div>
    </div>
  );
};
